var Gift = {};

//--------------
// Variables
//--------------
Gift.commandeForm = '.js-form-commande';
Gift.messageForm = '.js-form-messages-wrapper';

//--------------
// Functions
//--------------

/**
 * [Form scrollTop description]
 * @return {[type]} [description]
 */
Gift.goToTopForm = function(){
	$('html, body').animate({
		scrollTop: $(Gift.commandeForm).offset().top
	}, 'slow');
}

/**
 * [Form scrollTop to message description]
 * @return {[type]} [description]
 */
Gift.goToTopFormMessage = function(){
	$('html, body').animate({
		scrollTop: $(Gift.messageForm).offset().top - $('.js-header').outerHeight()*2
	}, 'slow');
}

/**
 * [changeStep description]
 * @param  {[type]} toStep      [description]
 * @param  {[type]} currentStep [description]
 * @return {[type]}             [description]
 */
Gift.changeStep = function(toStep, currentStep){
	Gift.goToTopForm();
	
	if(!$('.js-form-commande').valid() && currentStep)
		return false;

	if(currentStep){
		if(currentStep == 3){
			if(!$('#commande_prestation').val() && !$('#commande_montant').val()){
				$('.js-prestation-error-msg').removeClass('is-hidden');
				Gift.goToTopForm();

				return false;
			}
		}

		$('.js-steps__button[data-step="' + currentStep + '"]').addClass('is-validate');
	}

	$('.js-form__wrapper').hide();
	$('.js-form__wrapper[data-step="' + toStep + '"]').show();
	$('.js-steps__button').removeClass('is-active');
	$('.js-steps__button[data-step="' + toStep + '"]').addClass('is-active');
}

/**
 * [getGiftExp description]
 * @return {[type]} [description]
 */
Gift.getGiftExp = function(){
	var exp = {};
			exp.lastname 	= $('#exp_lastname').val();
			exp.firstname = $('#exp_firstname').val();
			exp.email			= $('#exp_email').val();
			exp.phone			= $('#exp_phone').val();
			exp.address		= $('#exp_address').val();
			exp.city			= $('#exp_city').val();
			exp.zipcode		= $('#exp_postalcode').val();

	return exp;
}

/**
 * [getGiftDest description]
 * @return {[type]} [description]
 */
Gift.getGiftDest = function(){
	var dest = {};
			dest.lastname 	= $('#dest_lastname').val();
			dest.firstname 	= $('#dest_firstname').val();
			dest.email			= $('#dest_email').val();
			dest.phone			= $('#dest_phone').val();
			dest.address		= $('#dest_address').val();
			dest.city				= $('#dest_city').val();
			dest.zipcode		= $('#dest_postalcode').val();

	return dest;
}

/**
 * [getGift description]
 * @return {[type]} [description]
 */
Gift.getGift = function(){
	var gift = {};
			gift.prestation = $('#commande_prestation').val();
			gift.prestation_id = $('#commande_prestation option:selected').attr('prestation-id');
			gift.cardAmount	= $('#commande_montant').val();
			gift.message		= $('#commande_message').val();

	return gift;
}

/**
 * [getSendType description]
 * @return {[type]} [description]
 */
Gift.getSendType = function(){
	var sendType = $('.js-send-type:checked').val();

	return sendType;
}

/**
 * [getSendBy description]
 * @return {[type]} [description]
 */
Gift.getSendBy = function(){
	var sendBy = $('.js-send-by:checked').val();

	return sendBy;
}

/**
 * [sendGiftMessage description]
 * @param  {[type]} exp      [description]
 * @param  {[type]} dest     [description]
 * @param  {[type]} gift     [description]
 * @param  {[type]} sendType [description]
 * @return {[type]}          [description]
 */
Gift.sendGiftMessage = function(exp, dest, gift, sendType, sendBy){

	$('.js-submit-gift').text('Traitement en cours ...');
	$('.js-submit-gift').prop('disabled', true);

	$.post({
		url: '/api/gift/send',
    type: 'POST',
    data: { exp: exp, dest: dest, gift: gift, sendType: sendType, sendBy: sendBy }
  })
	.done(function(data) {
		// redirect to payment
		if(data.datas.stripe && data.datas.stripe.hosted_invoice_url){
			//window.location.href = data.datas.stripe.hosted_invoice_url;

			$('.js-online-payment').prop('href', data.datas.stripe.hosted_invoice_url);
			$('.js-send-by-wrapper').fadeOut();
			$('.js-steps-wrapper').addClass('opacity-0');
			$('.js-form-messages-wrapper').fadeIn();
			Gift.goToTopFormMessage();
			App.successMessage('.js-form-commande');

		} else {
			Gift.error();
		}
	})
	.fail(function(err) {
		Gift.error();
	});
}

Gift.error = function(){
	$('.js-form-commande .js-form-message-success').hide();
	$('.js-send-by-wrapper').fadeOut();
	$('.js-steps-wrapper').addClass('opacity-0');
	$('.js-form-messages-wrapper').fadeIn();
	Gift.goToTopFormMessage();
	App.errorMessage('.js-form-commande');
};


//--------------
// Execution
//--------------

// Order Form Valdate
$('.js-form-commande').validate({
	rules: {
	    commande_montant: {
		    // required: true,
		    number: true
	    }
	},
	errorPlacement: function(error, element) {
	    error.insertBefore(element);
	}
});


// Go to step next
$('.js-next-step').click(function(){
	var currentStep = $(this).closest('.js-form__wrapper').data('step');
	var toStep = $(this).data('next');

	Gift.changeStep(toStep, currentStep);
});

// Return to specific step if validated
$('body').on('click', '.steps__button.is-validate', function(){
	var toStep = $(this).data('step');

	Gift.changeStep(toStep, null);
});

// Send gift message
$('.js-form-commande').submit(function(){
	var hasSendBy = typeof Gift.getSendBy() !== 'undefined';
	var hasSendType = typeof Gift.getSendType() !== 'undefined';
	
	if(!hasSendBy && !hasSendType){
		return false;
	}

	if(!$(this).valid()) {
		Gift.goToTopForm();
		return false;
	}

	var exp 			= Gift.getGiftExp();
	var dest 			= Gift.getGiftDest();
	var gift 			= Gift.getGift();
	var sendType 	= Gift.getSendType();
	var sendBy 		= Gift.getSendBy();

	Gift.sendGiftMessage(exp, dest, gift, sendType, sendBy);

	return false;
});

var resetSelect = true;
$('#commande_prestation').change(function(){
	$('#commande_montant').val('');

	//-- Hide "montant" error
	if($('#commande_montant').prev('.error').length > 0){
		$('#commande_montant').removeClass('error');
		$('#commande_montant').prev('.error').remove();
	}

	//-- Hide general error
	if(!$('.js-prestation-error-msg').hasClass('is-hidden')) {
		$('.js-prestation-error-msg').addClass('is-hidden');
	}

	resetSelect = true
});

$('#commande_montant').keypress(function(e){
	if(resetSelect){
		$('.js-select').val(null).trigger('change');

		//-- Hide general error
		if(!$('.js-prestation-error-msg').hasClass('is-hidden')) {
			$('.js-prestation-error-msg').addClass('is-hidden');
		}

		resetSelect = false;
	}
});

module.exports = Gift;